import React from "react";

import { localizer } from "../../../Translator";

import MailBoxGray from '../../../images/mailbox_gray.png'

import { Grid } from "@material-ui/core";
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { CardStyled } from "../../common/postal-address/CardStyled";

import { PostalAddress } from "./PostalAddress";
import { PostalAddressModal } from "./PostalAddressModal";

export class PostalAddressList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // Initial postal address list to be filled by parent component PostalAddressLayout
      postalAddresses: [],

      // Flag to open/close add postal address modal
      open: false
    }
  }

  /* Initialization of postal address list. Postal address list is given by parent props */
  componentDidMount() {
    this.setState({ postalAddresses: this.props.postalAddresses })
  }

  /* In case of parent state changes, this component needs to recharges */
  componentDidUpdate(prevProps) {
    if (prevProps.postalAddresses === this.props.postalAddresses) return

    this.setState({ postalAddresses: this.props.postalAddresses })
  }

  /* Handle modal open/close events */
  newPostalAddress = () => {
    this.setState({ open: !this.state.open })
  }

  handleCloseModal = () => {
    this.setState({ open: false })
  }

  render() {
    
    return (
      <React.Fragment>
        <Grid container direction="row" spacing={4} style={{ paddingTop: 25 }}>
          <Grid item md={3}>
            <CardStyled style={{ cursor: "pointer", backgroundImage: `url(${MailBoxGray})` }} onClick={this.newPostalAddress}>
              <CardContent>
                <Grid container direction="row" justify="center" alignItems="center" alignContent="center" style={{ textAlign: "center", position: "relative", marginTop: "calc(50% - 112px)" }} >
                  <Grid item md={12}>
                    <i className="fa-solid fa-plus addicon-custom"></i>
                  </Grid>
                  <Grid item md={12}>
                    <Typography className="typography-generic add-address">{localizer.PostalAddressAdd}</Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </CardStyled>
          </Grid>
          
          {this.state.postalAddresses.map(pa => {
            return (
              <Grid item md={3} key={pa.id}>
                <PostalAddress postalAddress={pa} defaultAddress={this.props.defaultAddress} handlePostalAddress={this.props.handlePostalAddress}></PostalAddress>
              </Grid>)
          })}

        </Grid>

        <PostalAddressModal openModal={this.state.open} handleCloseModal={this.handleCloseModal} handlePostalAddress={this.props.handlePostalAddress}></PostalAddressModal>
      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/postal-address/sections/PostalAddressList.js